import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { Form, Input, Checkbox } from "antd";
import _ from "lodash";

const UserPaths = ({initialValues}) => {
  
  const [form] = Form.useForm();

  const [useDefaultPaths, setUseDefaultPaths] = useState(true)

  const offset = {
    span: 24,
    offset: 0,
  };

  useEffect(() => {
    setUseDefaultPaths(initialValues.useDefaultPaths)
    form.resetFields();
  }, [form, initialValues])

  const formChanged = (changedFields) => {

    const newValues = {
      ...initialValues,
      ...form.getFieldsValue(),
    }

    if(changedFields.useDefaultPaths === initialValues.useDefaultPaths) {
      form.resetFields();
    } else {
      if(typeof(changedFields.useDefaultPaths) !==  'undefined') {
        if(changedFields.useDefaultPaths) {
          form.setFieldsValue({
            documentPath: "My Documents",
            tempPath: "UserTemp",
          });
        }
        else {
          form.setFieldsValue({
            documentPath: "",
            tempPath: "",
          });
          form.validateFields();
        }
      }
    }

    setUseDefaultPaths(newValues.useDefaultPaths)

    if(_.isEqual(initialValues, newValues)) {
      form.resetFields();
    }
  }

  return (
    <Form
      form={form}
      name="userPathsForm"
      labelAlign="left"
      initialValues={initialValues}
      onValuesChange={formChanged}
      autoComplete="off"
    >
      <Form.Item
        label=""
        name="useDefaultPaths"
        valuePropName="checked"
        style={{ marginBottom: "8px" }}
      >
        <Checkbox>Use System Default Paths</Checkbox>
      </Form.Item>
      <Form.Item
        label="Default Document Path"
        name="documentPath"
        rules={[
          {
            required: true,
            pattern: new RegExp(/^[a-zA-Z]:[\\](?!.*\\\\)+([^<>:"/|?*]*[\\]?)+$/),
            message: "Please enter a path",
          },
        ]}
        style={{ marginBottom: "8px" }}
        labelCol={offset}
        wrapperCol={offset}
      >
        <Input disabled={useDefaultPaths} placeholder="example: C:\ColumbiaSoft\Documents" />
      </Form.Item>
      <Form.Item
        label="Documents Temporary Path"
        name="tempPath"
        rules={[
        {
          required: true,
          pattern: new RegExp(/^[a-zA-Z]:[\\](?!.*\\\\)+([^<>:"/|?*]*[\\]?)+$/),
          message: "Please enter a path"
        }
        ]}
        style={{ marginBottom: "8px" }}
        labelCol={offset}
        wrapperCol={offset}
      >
        <Input disabled={useDefaultPaths} placeholder="example: C:\ColumbiaSoft\Temp" />
      </Form.Item>
      <Form.Item
        label="WebTools Auto Navigate Path"
        name="webToolsAutoPath"
        rules={[
          {
            whitespace: true,
            required: true,
            message: "AutoNavigate path required!",
          },
        ]}
        style={{ marginBottom: "8px" }}
        labelCol={offset}
        wrapperCol={offset}
      >
        <Input />
      </Form.Item>
    </Form>
  );
};

export default UserPaths;